var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.881,
    height: 13.881,
    viewBox: "0 0 13.881 13.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.125 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.351,17.2A1.851,1.851,0,1,1,17.2,15.351,1.851,1.851,0,0,1,15.351,17.2Zm0-2.776a.925.925,0,1,0,.925.925A.925.925,0,0,0,15.351,14.425Z",
    transform: "translate(-7.285 -7.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.976,17.2a1.851,1.851,0,1,1,1.851-1.851A1.851,1.851,0,0,1,2.976,17.2Zm0-2.776a.925.925,0,1,0,.925.925A.925.925,0,0,0,2.976,14.425Z",
    transform: "translate(0 -7.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.6,29.577a1.851,1.851,0,1,1,1.851-1.851A1.851,1.851,0,0,1,8.6,29.577Zm0-2.776a.925.925,0,1,0,.925.925A.925.925,0,0,0,8.6,26.8Z",
    transform: "translate(-3.311 -14.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.1,29.577a1.851,1.851,0,1,1,1.851-1.851A1.851,1.851,0,0,1,22.1,29.577Zm0-2.776a.925.925,0,1,0,.925.925A.925.925,0,0,0,22.1,26.8Z",
    transform: "translate(-11.259 -14.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.726,17.2a1.851,1.851,0,1,1,1.851-1.851A1.851,1.851,0,0,1,27.726,17.2Zm0-2.776a.925.925,0,1,0,.925.925A.925.925,0,0,0,27.726,14.425Z",
    transform: "translate(-14.57 -7.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.1,4.827a1.851,1.851,0,1,1,1.851-1.851A1.851,1.851,0,0,1,22.1,4.827Zm0-2.776a.925.925,0,1,0,.925.925A.925.925,0,0,0,22.1,2.05Z",
    transform: "translate(-11.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.6,4.827a1.851,1.851,0,1,1,1.851-1.851A1.851,1.851,0,0,1,8.6,4.827Zm0-2.776a.925.925,0,1,0,.925.925A.925.925,0,0,0,8.6,2.05Z",
    transform: "translate(-3.311)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.3245b2fead4421bcd6f4e888b1ca3b42.svg";
export { ForwardRef as ReactComponent };